<template>
  <v-card v-if=" loadPage">
    <v-sheet
      :color="`grey`"
      class="pa-3"
    >
      <v-skeleton-loader
        class="mx-auto"
        type="text-field, table, data-table"
      >
      </v-skeleton-loader>
    </v-sheet>
  </v-card>
  <v-card v-else>
    <v-card-title class="text-uppercase font-weight-bold">
      Liste des paiements
    </v-card-title>
    <v-divider></v-divider>
    <br>
    <div class="mx-auto">
      <v-card-text>
        <v-row>
          <v-col
            cols="12"
            offset-md="8"
            md="4"
          >
            <v-text-field
              v-model="search"
              :append-icon="icon.mdiMagnify"
              label="Rechercher"
              single-line
              hide-details
              dense
              outlined
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>

      <!-- Table -->
      <v-data-table
        id="list-refill"
        :headers="headers"
        :items="paiementList"
        :search="search"
        :items-per-page="itemPerPage"

        divider="true"
        class="table-kitchen-sink mx-auto"
      >
        <template #[`item.num`]="{item}">
          <div class="d-flex align-center p-5">
            <div class="d-flex flex-column ms-3 ">
              <span class="font-weight-semibold text-body-1 text--primary"> N° {{ item.num_ticket }} </span>
              <span class="custom-text--small">Envoyé le : {{ customDateFormat(item.created_at) }}</span>
              <span
                v-if="item.state==1"
                class="custom-text--small custom-red--text"
              >Fermé le : {{ customDateFormat(item.updated_at) }}</span>
              <v-spacer></v-spacer>
              <v-col
                cols="12"
                class="align-content-end"
              >
                <v-menu
                  offset-y
                  right
                  :close-on-content-click="false"
                  transition="slide-y-transition"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      class="ma-2 custom-btn"
                      text
                      v-on="on"
                    >
                      <v-icon
                        class="error--text"
                      >
                        {{ icon.mdiHistory }}
                      </v-icon>
                      <v-icon>
                        {{ icon.mdiMenuDown }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                  <!--                  <v-list-item-->
                  <!--                    v-for="(item, index) in items"-->
                  <!--                    :key="index"-->
                  <!--                  >-->
                  <!--                    <v-list-item-title>{{ item.title }}</v-list-item-title>-->
                  <!--                  </v-list-item>-->
                  </v-list>
                </v-menu>
              </v-col>
            </div>
          </div>
        </template>

        <template #[`item.type_depot`]="{item}">
          <div class="d-flex align-center">
            <div class="d-flex flex-column ms-3">
              <span class="d-block text-truncate text--primary">N°: <span class="font-weight-semibold"> {{item.customer_debt.num_debt}}</span></span>
              <span> Montant : <span class="font-weight-semibold custom-red--text">{{ withCurrency(item.amount)}} </span></span>
<!--              <v-btn
                class="mt-2 pl-5 pr-5 "
                color="info"
                rounded
                x-small
                outlined
                @click="showBill()"
              >
                Consulter la facture
              </v-btn>-->
            </div>
          </div>
        </template>

        <template #[`item.account_debite`]="{item}">
          <div class="d-flex align-center">
            <div class="d-flex flex-column ms-3">
              <span class="d-block font-weight-semibold text-truncate text--primary">Débiteur: <span class="font-weight-semibold">{{ item.account_debite }}</span></span>
              <span class="d-block font-weight-semibold text-truncate text--secondary">Créditeur: <span class="font-weight-semibold">{{ item.account_credite }}</span></span>
            </div>
          </div>
        </template>

        <template #[`item.amount`]="{item}">
          <div class="d-flex align-center">
            <div class="d-flex flex-column ms-3">
              <span class="d-block text-truncate text--primary">Montant: <span class="font-weight-semibold custom--success"> {{ withCurrency(item.amount) }}</span></span>
              <span class="d-block text-truncate text--primary">Type: <span class="font-weight-semibold"> {{ item.type_depot === DEPOT ?'Versement':'Virement' }}</span></span>
              <span class="d-block text-truncate text--primary">Service: <span class="font-weight-semibold"> {{ nomMoyenPaiement(item.payment_method_debit) }}</span></span>
              <span class="d-block text-truncate text--primary">Reférence: <span class="font-weight-semibold">{{ item.ref }}</span></span>
              <span
                v-if="item.file_name !=='0'"
                class="d-block text-truncate text--primary"
              >Reçu: <a
                class="text-decoration-none custom--info"
                @click="getFileLink(item)"
              >
                <v-icon class="custom--icon">{{ icon.mdiFileDocumentOutline }}</v-icon> {{ item.file }}</a>
              </span>
              <!--              <span
                v-if="item.file_name !=='0'"
                class="d-block text-truncate text&#45;&#45;primary"
              >Reçu: <a
                :href="item.file_url"
                target="_blank"
                class="text-decoration-none custom&#45;&#45;info"
              ><v-icon class="custom&#45;&#45;icon">{{ icon.mdiFileDocumentOutline }}</v-icon> {{ item.file_name }}</a></span>-->
            </div>
          </div>
        </template>

        <template #[`item.state`]="{item}">
          <div class="d-flex align-center">
            <div class="d-flex flex-column ms-3">
              <v-chip
                v-if="item.state==1"
                class="ma-2 text-center pr-5 pl-5"
                color="#F1FFE8FF"
              >
                <b class="success--text">Traité</b>
              </v-chip>
              <v-chip
                v-if="item.state==0"
                class="ma-2 text-center"
                color="#FFF6ECFF"
              >
                <b class="custom-warning--text">En cours</b>
              </v-chip>
              <v-chip
                v-if="item.state==-1"
                class="ma-2 text-center"
                color="#ae2619"
              >
                <b class="custom-warning--text">Rejeté</b>
              </v-chip>
            </div>
          </div>
        </template>
      </v-data-table>
    </div>
  </v-card>
</template>

<script>
import {
  ref, onBeforeMount, computed, onMounted, provide, onUpdated, nextTick, onBeforeUpdate, reactive,
} from '@vue/composition-api'
import {
  mdiFileDocumentOutline,
  mdiMagnify,
  mdiHistory,
  mdiMenuDown,
} from '@mdi/js'
import data from '@/views/finances/refillData'
import Http from '@/helpers/http'
import { useRouter } from '@core/utils'
import moment from 'moment'
import store from '@/store'
import { REFILL_REPOSITORY_NAME } from '@/helpers/constants/refill'
import useDynamicConstant from '@/helpers/useDynamicConstant'

export default {
  setup() {
    const DEPOT = 2
    const VIREMENT = 1
    const search = ref('')
    const listRefill = ref([])
    const refillList = ref([])
    const paiementList = ref([])
    const meansOfPayment = ref([])
    const loadPage = ref(true)
    const itemPerPage = 15
    const contrat = JSON.parse(localStorage.getItem('defaultContrat'))
    const numDist = JSON.parse(localStorage.getItem('customer')).num_dist
    const { route } = useRouter()
    const { billId } = route.value.params
    const { CURRENCY } = useDynamicConstant()

    const withCurrency = price => `${Number(price).toLocaleString()} ${CURRENCY}`

    const getPaiementList = () => {
      loadPage.value = true
      Http.get(`list-payment-debt/${JSON.parse(localStorage.getItem('defaultContrat')).id}/${billId}`)
        .then(response => {
          if (response.status === 200) {
            console.log(response.data)
            paiementList.value = response.data
            loadPage.value = false
          }
        })
    }

    const nomMoyenPaiement = moyenCode => {
      const name = meansOfPayment.value.filter(m => m.code === moyenCode)
      if (name.length > 0) return name[0].label

      return ''
    }
    const customDateFormat=(dateString)=>{
      const date = new Date(dateString)

      const day = date.getDate().toString().padStart(2, '0')
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const year = date.getFullYear().toString()
      const hours = date.getHours().toString().padStart(2, '0')
      const minutes = date.getMinutes().toString().padStart(2, '0')
      const seconds = date.getSeconds().toString().padStart(2, '0')
      const formattedDate = `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`

      return formattedDate
    }

    const loadMeansOfPayment = () => {
      Http.get('get-paymode')
        .then(response => {
          meansOfPayment.value = response.data
          console.log('meansOfPayment')
          console.log(response.data)
        })
        .catch(error => error)
    }
    const getFileLink = item => {
      const codeClient = (contrat.customer_type_code).split('-')

      store.dispatch('getUrlsOfFile', `dossiers-clients/${codeClient[0]}/${REFILL_REPOSITORY_NAME}/${item.file}`)
        .then(() => {
          // eslint-disable-next-line no-param-reassign
          item.file_url = store.getters.getFileUrl
          window.open(store.getters.getFileUrl, '_blank')
        })
    }

    onBeforeMount(() => {
      getPaiementList()
    })

    return {
      icon: {
        mdiFileDocumentOutline,
        mdiMagnify,
        mdiHistory,
        mdiMenuDown,
      },
      search,
      itemPerPage,
      withCurrency,
      DEPOT,
      VIREMENT,
      getFileLink,
      loadMeansOfPayment,
      nomMoyenPaiement,
      customDateFormat,
      loadPage,
      headers: [
        {
          text: 'Ticket', value: 'num', divider: true,
        },
        {
          text: 'Facture', value: 'type_depot', divider: true,
        },
        {
          text: 'Paiement', value: 'amount', divider: true,
        },
        {
          text: 'État', value: 'state', divider: true,
        },
      ],
      refillList,
      paiementList,
      listRefill,
      editedIndex: -1,
      editedItem: {},
      defaultItem: {},
    }
  },
  watch: {
  },

  created() {
    this.loadMeansOfPayment()
    Http.get(
      'local',
    ).then(rep => {
      console.log('Réponse : ', rep)
      this.listRefill = rep
    }).catch(error => {
      console.error('Erreur :', error)
    })
  },

  methods: {

    initialize() {
      // this.refillList = JSON.parse(JSON.stringify(data))
    },

    showBill() {
      //alert('go to sho  bill for specific month ')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@core/preset/preset/apps/refill.scss';

.custom--icon{
  height: 15px !important;
  width: 15px !important;
  color: #1E9FF2 !important;
}

.table-kitchen-sink ::v-deep {
  .v-data-table-header {
    white-space: nowrap;
  }
}

.border{
  border: #0c5460 solid 1px;
}

.custom-warning--text{
  color: darkorange;
  //background-color: #ffcfcf;
}

.custom-btn:hover{
  background-color: transparent !important;
}
</style>
